module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flat-index"
  }, [_c('div', {
    staticClass: "fi-mobile"
  }, [_c('fi-header-mobile', {
    attrs: {
      "is-mark": _vm.oMark
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "aboutus-mobile"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "help-list"
  }, [_c('ul', _vm._l((_vm.helpList), function(item, index) {
    return _c('li', {
      key: index,
      on: {
        "click": function($event) {
          return _vm.clickHelpListHandle(index)
        }
      }
    }, [_c('h2', [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('div', {
      staticClass: "help-item",
      class: {
        'active': _vm.activeArr[index]
      }
    }, [_c('p', {
      domProps: {
        "innerHTML": _vm._s(item.content)
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "arrow",
      class: {
        'acitve': _vm.activeArr[index]
      }
    })])
  }), 0)])]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "suggestions"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.title),
      expression: "title"
    }],
    attrs: {
      "placeholder": "请输入您的问题",
      "type": "text"
    },
    domProps: {
      "value": (_vm.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.title = $event.target.value
      }
    }
  }), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content),
      expression: "content"
    }],
    attrs: {
      "placeholder": "请输入您的问题描述"
    },
    domProps: {
      "value": (_vm.content)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.content = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": _vm.sendHandle
    }
  }, [_vm._v("提交")])])])]), _vm._v(" "), _c('fi-footer-mobile', {
    attrs: {
      "is-adv": false
    }
  }), _vm._v(" "), _c('fi-mark', {
    attrs: {
      "is-mark": _vm.oMark
    }
  })], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "ab-title"
  }, [_c('h1', [_vm._v("01")]), _vm._v(" "), _c('div', {
    staticClass: "ab-text"
  }, [_c('h2', [_vm._v("关于点点")]), _vm._v(" "), _c('p', [_vm._v("Online Service")])])]), _vm._v(" "), _c('div', {
    staticClass: "ab-content"
  }, [_c('p', [_vm._v("\n                        点击在线咨询按钮，连接人工客服。\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "online-btn"
  }, [_c('a', {
    attrs: {
      "href": "https://im2.zhongan.io/zaim/?accessId=1597999116941&tenantID=1514946886000043&color=yellow&themeID=DD001&channelId=94&subject=点点业务&biz=手网"
    }
  }, [_vm._v("在线咨询")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ab-title"
  }, [_c('h1', [_vm._v("02")]), _vm._v(" "), _c('div', {
    staticClass: "ab-text"
  }, [_c('h2', [_vm._v("常见问题")]), _vm._v(" "), _c('p', [_vm._v("Common Problem")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "ab-title"
  }, [_c('h1', [_vm._v("03")]), _vm._v(" "), _c('div', {
    staticClass: "ab-text"
  }, [_c('h2', [_vm._v("获取支持")]), _vm._v(" "), _c('p', [_vm._v("Get Support")])])]), _vm._v(" "), _c('div', {
    staticClass: "ab-content"
  }, [_c('p', [_vm._v("\n                        客服热线：4000666122(工作日9:00-18:00)\n                    ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ab-title"
  }, [_c('h1', [_vm._v("04")]), _vm._v(" "), _c('div', {
    staticClass: "ab-text"
  }, [_c('h2', [_vm._v("意见反馈")]), _vm._v(" "), _c('p', [_vm._v("Suggestions")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-65c2968e"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/HelpCenterMobile.vue
// module id = 371
// module chunks = 1